module.exports = __webpack_public_path__ + "img/view.05769b57.png";